import { Utilities } from 'core/domains';
import type { Search } from 'core/domains';

export const initialState: Search = {
  data: [],
  previewSearch: [],
  isRunning: false,
  isRunningPreview: false,
  isSearchSubmit: false,
  message: '',
  statusPreview: Utilities.STATUS.IDLE,
  notFound: false,
  queryOptions: {} as Search['queryOptions'],
  status: Utilities.STATUS.IDLE,
};
